const TqlExamples = [
    {
        "result": {},
        "runDisabled": false,
        "modal": false,
        "resetModal": false,
        "welcomeModal": false,
        "aliasVisible": true,
        "loading": false,
        "isEditing": false,
        "errorLoadingCustomerView": false,
        "query": "MATCH (SOFTWARE:a) WHERE a.title = \"Internet Explore\" RETURN a",
        "hasLeftNode": true,
        "showArrow": false,
        "selectedRelationship": "VENDOR_OF",
        "selectableRelationshipNodes": [],
        "selectableRelationships": [
            {
                "label": "VENDOR_OF",
                "direction": "up"
            }
        ],
        "selectedAlias": "Select Attribute",
        "selectedAliasList": [],
        "aliasOptions": [
            {
                "name": "SOFTWARE:category",
                "alias": "a"
            }, {
                "name": "SOFTWARE:edition",
                "alias": "a"
            }, {
                "name": "SOFTWARE:technopedia_id",
                "alias": "a"
            }, {
                "name": "SOFTWARE:title",
                "alias": "a"
            }, {
                "name": "SOFTWARE:version",
                "alias": "a"
            }, {
                "name": "SOFTWARE:version_group",
                "alias": "a"
            }, {
                "name": "SOFTWARE:version_order",
                "alias": "a"
            }
        ],
        "nodes": [
            {
                "node": "SOFTWARE",
                "alias": "a",
                "attributes": [
                    {
                        "id": "73b5b81d-25bf-45c2-8492-12739b695235",
                        "alias": "a",
                        "property": "title",
                        "clause": "=",
                        "value": "Internet Explorer"
                    }
                ],
                "return": ["a"],
                "selectableAttributes": [
                    "category",
                    "edition",
                    "technopedia_id",
                    "title",
                    "version",
                    "version_group",
                    "version_order"
                ],
                "selectableCategories": [
                    "Accounting",
                    "Alerts and Monitoring Tools",
                    "Analytics",
                    "Anti Virus and Malware",
                    "Application Architecture and Design",
                    "Application Servers",
                    "Application Testing and QA",
                    "Archiving and Content Storage",
                    "Backup and Recovery",
                    "Banking",
                    "Blogs & Wikis",
                    "Business Intelligence (BI) Suites",
                    "Business Metrics and Reporting Tools",
                    "Business Performance Management",
                    "Capacity Planning",
                    "Cartography/Mapping",
                    "CD & DVD Recording",
                    "Collaboration Platforms",
                    "Compiler and Decompiler",
                    "Computer Hardware Configuration Management",
                    "Computer-Based Training",
                    "Conferencing",
                    "Configuration Management Database (CMDB)",
                    "Connectivity Tools",
                    "Content Delivery and Distribution",
                    "Cross-Industry ERP Suites",
                    "Customer Relationship Management (CRM) Suites",
                    "Customer Service & Support",
                    "Data Mining and Warehousing",
                    "Data Security and Encryption",
                    "Demand Management",
                    "Desktop Enhancements",
                    "Desktop Publishing (DTP)",
                    "Development Environment",
                    "Dictionary and Encyclopedia",
                    "Distribution and Transportation Management",
                    "Document and Records Management",
                    "Document Capturing and Imaging",
                    "Drivers",
                    "Electronic Design Automation",
                    "Enterprise",
                    "Enterprise Integration",
                    "Fault Management",
                    "File Managers",
                    "Financial Management",
                    "Financial Management Suites",
                    "Firewall and Intrusion Prevention",
                    "Games",
                    "Graphics and Image Editing",
                    "Hardware Virtualization",
                    "Help and Service Desk",
                    "Hospital Management",
                    "Hypervisor",
                    "IBM i",
                    "Identity and Access Management",
                    "Industry-Specific ERP Suites",
                    "Instant Messaging",
                    "Insurance",
                    "Inventory Management",
                    "Investment",
                    "IT Asset Maintenance & Support",
                    "IT Asset Management",
                    "License Management",
                    "Life Sciences",
                    "Lifestyle and Personal Improvement",
                    "Location-Aware Services",
                    "Mac OS",
                    "Mail Servers",
                    "Mainframe",
                    "Manufacturing Process Management",
                    "Marketing Management",
                    "Mathematics and Physics",
                    "Mechanical CAD, CAM, and CAE Software",
                    "Medical software",
                    "Merchandising",
                    "Multimedia Players",
                    "Navigation Tools",
                    "Network Performance Management",
                    "Other Educational Software",
                    "Other Engineering & Scientific Software",
                    "Other Entertainment Software",
                    "Other Hobbies Software",
                    "Other Multimedia and Graphics Tools",
                    "Other Operating Systems",
                    "Other References Software",
                    "Other Utilities",
                    "Payment Systems",
                    "Payroll & Time Accounting",
                    "Peer-to-peer (P2P) Networking",
                    "Personal",
                    "PIM & Contact Managers",
                    "Plant/Shop Control",
                    "Point of Sale",
                    "Presence",
                    "Presentation",
                    "Procurement and Sourcing",
                    "Product and Portfolio Management",
                    "Product Data Management",
                    "Product Design",
                    "Productivity Suites",
                    "Recruitment & Training",
                    "Regulatory and Compliance Management",
                    "Religious Software",
                    "Sales and Operations Planning",
                    "Sales Management",
                    "Security Suites",
                    "Social Networking",
                    "Software Configuration Management",
                    "Software Virtualization",
                    "Spatial Analysis",
                    "Sports Software",
                    "Spreadsheets",
                    "Storage Resource Management",
                    "Storage Virtualization",
                    "Store Operations",
                    "Supplier Relationship Management",
                    "Supply Chain Management (SCM) Suites",
                    "Synchronization Tools",
                    "Taxation",
                    "Unclassified Middleware",
                    "Unclassified Software",
                    "UNIX",
                    "Video and Audio Editing",
                    "Virtualization Management Software",
                    "Vulnerability Management",
                    "Warehouse Management System",
                    "Web Browsers",
                    "Web Content Management",
                    "Web Design",
                    "Web Servers",
                    "Windows",
                    "Word Processors",
                    "Workflow and Business Process Management",
                    "Workforce Management"
                ]
            }, {
                "node": "",
                "alias": "b",
                "attributes": [],
                "return": ["b"]
            }
        ],
        "relationship": {
            "nodeIndex": 1,
            "alias": "",
            "value": "",
            "direction": "",
            "showNode": false
        },
        "showRelationshipButton": true,
        "selectedExample": "Examples",
        "exampleModal": {
            "index": null,
            "showModal": false,
            "title": "",
            "body": ""
        }
    }, {
        "result": {},
        "runDisabled": false,
        "modal": false,
        "resetModal": false,
        "welcomeModal": false,
        "aliasVisible": true,
        "loading": false,
        "selectedRelationship": "VENDOR_OF",
        "isEditing": false,
        "errorLoadingCustomerView": false,
        "query": "MATCH (SOFTWARE:a)<-[VENDOR_OF:c]-(MANUFACTURER:b) WHERE a.category = \"Graphics and Image Editing\" AND b.title = \"Adobe Systems\" RETURN a, b",
        "hasLeftNode": true,
        "showArrow": true,
        "selectableRelationshipNodes": ["MANUFACTURER"],
        "selectableRelationships": [
            {
                "label": "VENDOR_OF",
                "direction": "up"
            }
        ],
        "selectedAlias": "Select Attribute",
        "selectedAliasList": [],
        "aliasOptions": [
            {
                "name": "SOFTWARE:category",
                "alias": "a"
            }, {
                "name": "SOFTWARE:edition",
                "alias": "a"
            }, {
                "name": "SOFTWARE:technopedia_id",
                "alias": "a"
            }, {
                "name": "SOFTWARE:title",
                "alias": "a"
            }, {
                "name": "SOFTWARE:version",
                "alias": "a"
            }, {
                "name": "SOFTWARE:version_group",
                "alias": "a"
            }, {
                "name": "SOFTWARE:version_order",
                "alias": "a"
            }, {
                "name": "MANUFACTURER:title",
                "alias": "b"
            }
        ],
        "nodes": [
            {
                "node": "SOFTWARE",
                "alias": "a",
                "attributes": [
                    {
                        "id": "a3584e3f-e430-4858-96e3-f24b52d86efa",
                        "alias": "a",
                        "property": "category",
                        "clause": "=",
                        "value": "Graphics and Image Editing"
                    }
                ],
                "return": ["a"],
                "selectableAttributes": [
                    "category",
                    "edition",
                    "technopedia_id",
                    "title",
                    "version",
                    "version_group",
                    "version_order"
                ],
                "selectableCategories": [
                    "Accounting",
                    "Alerts and Monitoring Tools",
                    "Analytics",
                    "Anti Virus and Malware",
                    "Application Architecture and Design",
                    "Application Servers",
                    "Application Testing and QA",
                    "Archiving and Content Storage",
                    "Backup and Recovery",
                    "Banking",
                    "Blogs & Wikis",
                    "Business Intelligence (BI) Suites",
                    "Business Metrics and Reporting Tools",
                    "Business Performance Management",
                    "Capacity Planning",
                    "Cartography/Mapping",
                    "CD & DVD Recording",
                    "Collaboration Platforms",
                    "Compiler and Decompiler",
                    "Computer Hardware Configuration Management",
                    "Computer-Based Training",
                    "Conferencing",
                    "Configuration Management Database (CMDB)",
                    "Connectivity Tools",
                    "Content Delivery and Distribution",
                    "Cross-Industry ERP Suites",
                    "Customer Relationship Management (CRM) Suites",
                    "Customer Service & Support",
                    "Data Mining and Warehousing",
                    "Data Security and Encryption",
                    "Demand Management",
                    "Desktop Enhancements",
                    "Desktop Publishing (DTP)",
                    "Development Environment",
                    "Dictionary and Encyclopedia",
                    "Distribution and Transportation Management",
                    "Document and Records Management",
                    "Document Capturing and Imaging",
                    "Drivers",
                    "Electronic Design Automation",
                    "Enterprise",
                    "Enterprise Integration",
                    "Fault Management",
                    "File Managers",
                    "Financial Management",
                    "Financial Management Suites",
                    "Firewall and Intrusion Prevention",
                    "Games",
                    "Graphics and Image Editing",
                    "Hardware Virtualization",
                    "Help and Service Desk",
                    "Hospital Management",
                    "Hypervisor",
                    "IBM i",
                    "Identity and Access Management",
                    "Industry-Specific ERP Suites",
                    "Instant Messaging",
                    "Insurance",
                    "Inventory Management",
                    "Investment",
                    "IT Asset Maintenance & Support",
                    "IT Asset Management",
                    "License Management",
                    "Life Sciences",
                    "Lifestyle and Personal Improvement",
                    "Location-Aware Services",
                    "Mac OS",
                    "Mail Servers",
                    "Mainframe",
                    "Manufacturing Process Management",
                    "Marketing Management",
                    "Mathematics and Physics",
                    "Mechanical CAD, CAM, and CAE Software",
                    "Medical software",
                    "Merchandising",
                    "Multimedia Players",
                    "Navigation Tools",
                    "Network Performance Management",
                    "Other Educational Software",
                    "Other Engineering & Scientific Software",
                    "Other Entertainment Software",
                    "Other Hobbies Software",
                    "Other Multimedia and Graphics Tools",
                    "Other Operating Systems",
                    "Other References Software",
                    "Other Utilities",
                    "Payment Systems",
                    "Payroll & Time Accounting",
                    "Peer-to-peer (P2P) Networking",
                    "Personal",
                    "PIM & Contact Managers",
                    "Plant/Shop Control",
                    "Point of Sale",
                    "Presence",
                    "Presentation",
                    "Procurement and Sourcing",
                    "Product and Portfolio Management",
                    "Product Data Management",
                    "Product Design",
                    "Productivity Suites",
                    "Recruitment & Training",
                    "Regulatory and Compliance Management",
                    "Religious Software",
                    "Sales and Operations Planning",
                    "Sales Management",
                    "Security Suites",
                    "Social Networking",
                    "Software Configuration Management",
                    "Software Virtualization",
                    "Spatial Analysis",
                    "Sports Software",
                    "Spreadsheets",
                    "Storage Resource Management",
                    "Storage Virtualization",
                    "Store Operations",
                    "Supplier Relationship Management",
                    "Supply Chain Management (SCM) Suites",
                    "Synchronization Tools",
                    "Taxation",
                    "Unclassified Middleware",
                    "Unclassified Software",
                    "UNIX",
                    "Video and Audio Editing",
                    "Virtualization Management Software",
                    "Vulnerability Management",
                    "Warehouse Management System",
                    "Web Browsers",
                    "Web Content Management",
                    "Web Design",
                    "Web Servers",
                    "Windows",
                    "Word Processors",
                    "Workflow and Business Process Management",
                    "Workforce Management"
                ]
            }, {
                "node": "MANUFACTURER",
                "alias": "b",
                "attributes": [
                    {
                        "id": "52de73ef-cc38-4fa6-abed-f32b424a662d",
                        "alias": "b",
                        "property": "title",
                        "clause": "=",
                        "value": "Adobe Systems"
                    }
                ],
                "return": ["b"],
                "selectableAttributes": ["title"],
                "selectableCategories": [
                    "Basic Mobile Phones",
                    "Blade Enclosures",
                    "Bridges",
                    "Converged Infrastructure",
                    "Copier",
                    "CRT Displays",
                    "Database Appliances",
                    "Desktops",
                    "Direct Attached Storage (DAS)",
                    "Dot Matrix",
                    "Fax Machine",
                    "Feature Phones",
                    "Firewalls and Security Appliances",
                    "Flat Panel Displays",
                    "Gateways",
                    "Handhelds",
                    "Handsets",
                    "Hubs/Switches",
                    "Human Interface Devices",
                    "Imaging/Video Devices",
                    "Inkjet Printers",
                    "KVM Switches",
                    "Labeling Devices",
                    "Laser Printers",
                    "Light Source System",
                    "Load Balancers",
                    "Mainframes",
                    "Modems",
                    "Multifunction",
                    "Network Attached Storage (NAS)",
                    "Notebooks",
                    "Other Printing Devices",
                    "Point of Sale (POS)",
                    "Print Servers",
                    "Projectors",
                    "Rack Enclosures",
                    "Routers",
                    "Search Appliances",
                    "Servers",
                    "Smartphones",
                    "Sound/Audio Devices",
                    "Storage Area Networks (SAN)",
                    "Tape Systems",
                    "Telephone Exchanges",
                    "Thermal Printers",
                    "Thin Clients",
                    "Unclassified Hardware",
                    "Unclassified Network Equipment",
                    "Unclassified Storage",
                    "Voice and Multimedia Communication Systems",
                    "Wireless Access Points",
                    "Workstations"
                ]
            }
        ],
        "relationship": {
            "nodeIndex": 1,
            "alias": "c",
            "value": "VENDOR_OF",
            "direction": "up",
            "showNode": true
        },
        "showRelationshipButton": false,
        "selectedExample": "Examples",
        "exampleModal": {
            "index": null,
            "showModal": false,
            "title": "",
            "body": ""
        }
    }, {
        "result": {},
        "runDisabled": true,
        "modal": false,
        "resetModal": false,
        "welcomeModal": false,
        "aliasVisible": true,
        "loading": false,
        "selectedRelationship": "VENDOR_OF",
        "isEditing": false,
        "errorLoadingCustomerView": false,
        "query": "MATCH (HARDWARE:a)<-[VENDOR_OF:c]-(MANUFACTURER:b) WHERE a.category = \"Workstat" +
                "ions\" AND a.date_introduced > \"{enter value}\" AND b.title = \"IBM\" RETURN a," +
                " b",
        "hasLeftNode": true,
        "showArrow": true,
        "selectableRelationshipNodes": ["MANUFACTURER"],
        "selectableRelationships": [
            {
                "label": "VENDOR_OF",
                "direction": "up"
            }
        ],
        "selectedAlias": "Select Attribute",
        "selectedAliasList": [],
        "aliasOptions": [
            {
                "name": "HARDWARE:category",
                "alias": "a"
            }, {
                "name": "HARDWARE:date_introduced",
                "alias": "a"
            }, {
                "name": "HARDWARE:model",
                "alias": "a"
            }, {
                "name": "HARDWARE:profile",
                "alias": "a"
            }, {
                "name": "HARDWARE:technopedia_id",
                "alias": "a"
            }, {
                "name": "HARDWARE:title",
                "alias": "a"
            }, {
                "name": "MANUFACTURER:title",
                "alias": "b"
            }
        ],
        "nodes": [
            {
                "node": "HARDWARE",
                "alias": "a",
                "attributes": [
                    {
                        "id": "d697e72a-f7d5-478c-8380-a40f071fea20",
                        "alias": "a",
                        "property": "category",
                        "clause": "=",
                        "value": "Workstations"
                    }, {
                        "id": "65f8e062-2070-4983-bc07-224df209e486",
                        "alias": "a",
                        "property": "date_introduced",
                        "clause": ">",
                        "value": "1/30/2015"
                    }
                ],
                "return": ["a"],
                "selectableAttributes": [
                    "category",
                    "date_introduced",
                    "model",
                    "profile",
                    "technopedia_id",
                    "title"
                ],
                "selectableCategories": [
                    "Basic Mobile Phones",
                    "Blade Enclosures",
                    "Bridges",
                    "Converged Infrastructure",
                    "Copier",
                    "CRT Displays",
                    "Database Appliances",
                    "Desktops",
                    "Direct Attached Storage (DAS)",
                    "Dot Matrix",
                    "Fax Machine",
                    "Feature Phones",
                    "Firewalls and Security Appliances",
                    "Flat Panel Displays",
                    "Gateways",
                    "Handhelds",
                    "Handsets",
                    "Hubs/Switches",
                    "Human Interface Devices",
                    "Imaging/Video Devices",
                    "Inkjet Printers",
                    "KVM Switches",
                    "Labeling Devices",
                    "Laser Printers",
                    "Light Source System",
                    "Load Balancers",
                    "Mainframes",
                    "Modems",
                    "Multifunction",
                    "Network Attached Storage (NAS)",
                    "Notebooks",
                    "Other Printing Devices",
                    "Point of Sale (POS)",
                    "Print Servers",
                    "Projectors",
                    "Rack Enclosures",
                    "Routers",
                    "Search Appliances",
                    "Servers",
                    "Smartphones",
                    "Sound/Audio Devices",
                    "Storage Area Networks (SAN)",
                    "Tape Systems",
                    "Telephone Exchanges",
                    "Thermal Printers",
                    "Thin Clients",
                    "Unclassified Hardware",
                    "Unclassified Network Equipment",
                    "Unclassified Storage",
                    "Voice and Multimedia Communication Systems",
                    "Wireless Access Points",
                    "Workstations"
                ]
            }, {
                "node": "MANUFACTURER",
                "alias": "b",
                "attributes": [
                    {
                        "id": "81c6b7c4-2d0b-4558-8141-f093c8a73537",
                        "alias": "b",
                        "property": "title",
                        "clause": "=",
                        "value": "IBM"
                    }
                ],
                "return": ["b"],
                "selectableAttributes": ["title"],
                "selectableCategories": [
                    "Basic Mobile Phones",
                    "Blade Enclosures",
                    "Bridges",
                    "Converged Infrastructure",
                    "Copier",
                    "CRT Displays",
                    "Database Appliances",
                    "Desktops",
                    "Direct Attached Storage (DAS)",
                    "Dot Matrix",
                    "Fax Machine",
                    "Feature Phones",
                    "Firewalls and Security Appliances",
                    "Flat Panel Displays",
                    "Gateways",
                    "Handhelds",
                    "Handsets",
                    "Hubs/Switches",
                    "Human Interface Devices",
                    "Imaging/Video Devices",
                    "Inkjet Printers",
                    "KVM Switches",
                    "Labeling Devices",
                    "Laser Printers",
                    "Light Source System",
                    "Load Balancers",
                    "Mainframes",
                    "Modems",
                    "Multifunction",
                    "Network Attached Storage (NAS)",
                    "Notebooks",
                    "Other Printing Devices",
                    "Point of Sale (POS)",
                    "Print Servers",
                    "Projectors",
                    "Rack Enclosures",
                    "Routers",
                    "Search Appliances",
                    "Servers",
                    "Smartphones",
                    "Sound/Audio Devices",
                    "Storage Area Networks (SAN)",
                    "Tape Systems",
                    "Telephone Exchanges",
                    "Thermal Printers",
                    "Thin Clients",
                    "Unclassified Hardware",
                    "Unclassified Network Equipment",
                    "Unclassified Storage",
                    "Voice and Multimedia Communication Systems",
                    "Wireless Access Points",
                    "Workstations"
                ]
            }
        ],
        "relationship": {
            "nodeIndex": 1,
            "alias": "c",
            "value": "VENDOR_OF",
            "direction": "up",
            "showNode": true
        },
        "showRelationshipButton": false,
        "selectedExample": "Examples",
        "exampleModal": {
            "index": null,
            "showModal": false,
            "title": "",
            "body": ""
        }
    }
];

export default TqlExamples;


// WEBPACK FOOTER //
// ./src/config/TqlExamples.js